import React from 'react';
import { Circle } from 'react-konva';
import withMouseEvent from '../../hoc/withMouseEvent';

const Dot = React.forwardRef(({ attrs }, ref) => {
  return (<Circle {...attrs} ref={ref} />)
});

export default withMouseEvent(Dot);